module.exports = __webpack_public_path__ + "img/passport_banner.8d1a2eb9.jpg";